import { handleActions } from 'redux-actions';
import * as ACTION_TYPES from '../actions/commonActionTypes';

const initialState = {
    marquee: {},
    footer: '',
    promoWells: {},
    pricingDetails: []
};

export default handleActions({
    [ACTION_TYPES.UPDATE_MARQUEE]: (state, action) => ({
        ...state,
        marquee: action.payload
    }),
    [ACTION_TYPES.UPDATE_FOOTER]: (state, action) => ({
        ...state,
        footer: action.payload
    }),
    [ACTION_TYPES.UPDATE_PROMO_WELLS]: (state, action) => ({
        ...state,
        promoWells: action.payload
    }),
    [ACTION_TYPES.UPDATE_PRICING_DETAILS]: (state, action) => ({
        ...state,
        pricingDetails: action.payload
    })
}, initialState);
